import React, { Component } from 'react'
import { InlineMath, BlockMath } from 'react-katex';
import {
  Container,
  Header,
} from 'semantic-ui-react'

export const cumulative_cut_list_threshold = 0.999

export function get_cumulative_list(list, delta=1) {
  var cumulative_list = []
  for(var i = 0; i < list.length; i++){
    cumulative_list.push(
      list.slice(0, i + 1).reduce((a, b) => ( a + b )) * delta < 1 ? list.slice(0, i + 1).reduce((a, b) => ( a + b ))  * delta : 1
    )
  }
  return cumulative_list
}


// 
// gamma distribution
const gamma_function = require('gamma')

export const gamma_lambda_init = 2.0
export const gamma_k_init = 9.0
export const gamma_max_plot = 30
export const gamma_delta = 1

export function GetKatexGammaFunctionName() {
  return (
    <BlockMath>{`
    P\\left(x | \\lambda, k \\right) = \\frac{\\lambda^k}{\\Gamma\\left(k \\right)}x^{k-1}e^{-\\lambda x}
    `}</BlockMath>
  )
}

export function get_gamma_arg_list(lambda,k) {

  var lambda = Number(lambda)
  var k = Number(k)
  
  var k_m5 = lambda - 5 * k
  var k_p5 = lambda + 5 * k

  var arg_list = []
  for(var i = 0; i <= gamma_max_plot; i++ ) {
    arg_list.push(i)
  }
  return arg_list
}

export function get_gamma_list(lambda,k) {

  var lambda = Number(lambda)
  var k = Number(k)

  var array = []
  for(var arg of get_gamma_arg_list(lambda, k)){
    var value = lambda ** k * arg ** (k - 1) * Math.E ** (-1 * lambda * arg) / gamma_function(k)
    array.push(value)
  }
  return array
}


// 
// gamma distribution
export const geometric_p_init = 0.1
export const geometric_max_plot = 30
export const geometric_delta = 1

export function GetKatexGeometricFunctionName() {
  return (
    <BlockMath>{`
    P\\left(k | p \\right) = p\\left(1 - p \\right)^{ k - 1 }
    `}</BlockMath>
  )
}

export function get_geometric_arg_list(p) {

  var arg_list = []
  for(var i = 1; i <= geometric_max_plot; i++ ) {
    arg_list.push(i)
  }
  return arg_list
}

export function get_geometric_list(p) {

  var p = Number(p)

  var array = []
  for(var arg of get_geometric_arg_list(p)){
    var value = p * (1 - p) ** (arg - 1)
    array.push(value)
  }
  return array
}


